import { categories } from 'components/filters/components/content-category-filter/categories';
import { alarmFiltersInitialState } from './initialState/alarmInitialState';

export const transformAdvancedFilters = (data, _platform) => {
  // create a copy of alarmFiltersInitialState platform filters. don't use reference
  const filters = { ...alarmFiltersInitialState[_platform] };

  // resourceTypeFilter OR mediaTypeFilter
  // اسم فیلد فیلتر نوع محتوا و نوع منبع شباهت دارن ولی مقادیرشون با توجه به پلتفرم فرق داره
  if (data?.media_types?.length > 0) {
    if (_platform === 'news') {
      filters.resourceTypeFilter = {
        ...filters.resourceTypeFilter,
        selectedIds: data?.media_types || [],
        hasFilter: data?.media_types?.length > 0,
        isDisabled: !(data?.media_types?.length > 0),
      };
    } else if (_platform !== 'newspaper') {
      filters.mediaTypeFilter = {
        ...filters.mediaTypeFilter,
        selectedIds: data?.media_types?.includes('document')
          ? [
              ...(data?.media_types.filter(
                (type) =>
                  type !== 'poll' && type !== 'document' && type !== 'article'
              ) || []),
              'other',
            ]
          : data?.media_types || [],
        hasFilter: data?.media_types?.length > 0,
        isDisabled: !(data?.media_types?.length > 0),
      };
    }
  }

  // contentBasedFilter
  if (data?.resource_influence_categories) {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        influenceRate: {
          ...filters.contentBasedFilter.selectedObjects.influenceRate,
          active: Boolean(data?.resource_influence_categories),
          selectedIds: data?.resource_influence_categories,
        },
      },
    };
  }
  if (_platform === 'news') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
      },
    };
  } else if (_platform === 'instagram') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        comment: {
          ...filters.contentBasedFilter.selectedObjects.comment,
          active: !!data?.min_comment,
          min: data?.min_comment || null,
          max: data?.max_comment || null,
        },
        like: {
          ...filters.contentBasedFilter.selectedObjects.like,
          active: !!data?.min_like,
          min: data?.min_like || null,
          max: data?.max_like || null,
        },
      },
    };
  } else if (_platform === 'telegram') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        view: {
          ...filters.contentBasedFilter.selectedObjects.view,
          active: !!data?.min_view,
          min: data?.min_view || null,
          max: data?.max_view || null,
        },
      },
    };
  } else if (_platform === 'twitter') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        copy: {
          ...filters.contentBasedFilter.selectedObjects.copy,
          active: !!data?.min_copy,
          min: data?.min_copy || null,
          max: data?.max_copy || null,
        },
        like: {
          ...filters.contentBasedFilter.selectedObjects.like,
          active: !!data?.min_like,
          min: data?.min_like || null,
          max: data?.max_like || null,
        },
      },
    };
  } else if (_platform === 'virasty') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        copy: {
          ...filters.contentBasedFilter.selectedObjects.copy,
          active: !!data?.min_copy,
          min: data?.min_copy || null,
          max: data?.max_copy || null,
        },
        reaction: {
          ...filters.contentBasedFilter.selectedObjects.reaction,
          active: !!data?.min_reactions,
          min: data?.min_reactions || null,
          max: data?.max_reactions || null,
        },
      },
    };
  }

  // subjectFilter
  if (data?.resource_categories?.length > 0) {
    filters.subjectFilter = {
      ...filters.subjectFilter,
      selectedIds: data?.resource_categories || [],
      hasFilter: data?.resource_categories?.length > 0,
      isDisabled: !(data?.resource_categories?.length > 0),
    };
  }

  // sentimentFilter
  if (data?.sentiments?.length > 0) {
    filters.sentimentFilter = {
      ...filters.sentimentFilter,
      hasFilter: true,
      isDisabled: false,
      selectedValues: {
        negative: data.sentiments.includes('negative'),
        neutral: data.sentiments.includes('neutral'),
        positive: data.sentiments.includes('positive'),
      },
    };
  }

  // ageFilter
  if (data?.m3_age?.length > 0) {
    filters.ageFilter = {
      ...filters.ageFilter,
      selectedIds: data?.m3_age || [],
      hasFilter: data?.m3_age?.length > 0,
      isDisabled: !(data?.m3_age?.length > 0),
    };
  }

  // genderFilter
  if (data?.gender?.length > 0) {
    filters.genderFilter = {
      ...filters.genderFilter,
      selectedIds: data?.gender || [],
      hasFilter: data?.gender?.length > 0,
      isDisabled: !(data?.gender?.length > 0),
    };
  }

  // resourceCategoryFilter
  if (data?.tag_id || data?.not_tag_id) {
    const isInclude = !!data?.tag_id;
    const hasValue = !!data?.tag_id || !!data?.not_tag_id;
    filters.resourceCategoryFilter = {
      ...filters.resourceCategoryFilter,
      selectedValue: isInclude ? data.tag_id : data.not_tag_id,
      filterType: isInclude ? 'include' : 'exclude',
      hasFilter: hasValue,
      isDisabled: !hasValue,
    };
  }

  // resourcesFilter
  if (data?.resource_ids?.length > 0 || data?.not_resource_ids?.length > 0) {
    const _resourceIds = {};

    data?.resource_ids?.forEach((key) => {
      _resourceIds[key] = {
        title: key,
        id: key,
      };
    });
    data?.not_resource_ids?.forEach((key) => {
      _resourceIds[key] = {
        title: key,
        id: key,
      };
    });

    filters.resourcesFilter = {
      ...filters.resourcesFilter,
      selectedItems: _resourceIds,
      selectedValue: data?.resource_ids?.length > 0 ? 'include' : 'exclude',
      hasFilter:
        data?.resource_ids?.length > 0 || data?.not_resource_ids?.length > 0,
      isDisabled:
        !(data?.resource_ids?.length > 0) &&
        !(data?.not_resource_ids?.length > 0),
    };
  }

  // countryFilter
  if (data?.resource_countries?.length > 0) {
    filters.countryFilter = {
      ...filters.countryFilter,
      selectedIds: data?.resource_countries || [],
      hasFilter: data?.resource_countries?.length > 0,
      isDisabled: !(data?.resource_countries?.length > 0),
    };
  }

  // languageFilter
  if (data?.langs?.length > 0) {
    filters.languageFilter = {
      ...filters.languageFilter,
      selectedValue: data?.langs?.[0] || 'all',
      hasFilter: data?.langs?.[0] !== 'all',
      isDisabled: data?.langs?.[0] === 'all',
    };
  }

  // contentCategoryFilter
  if (data?.categories?.length > 0) {
    const _categories = {};

    data?.categories?.forEach((key) => {
      _categories[key] = [];
    });

    Object.keys(_categories)?.map((cat) => {
      categories?.[cat]?.forEach((subCat) => {
        if (data?.sub_categories?.includes(subCat))
          _categories[cat].push(subCat);
      });
    });

    filters.contentCategoryFilter = {
      ...filters.contentCategoryFilter,
      selectedCategories: _categories,
      hasFilter: !!_categories,
      isDisabled: !_categories,
    };
  }

  if (data?.rates?.length > 0) {
    filters.ratingFilter = {
      ...filters.ratingFilter,
      selectedIds: data?.rates || [],
      hasFilter: data?.rates?.length > 0,
      isDisabled: !(data?.rates?.length > 0),
    };
  }

  return filters;
};
